import React, { useState } from 'react';
import { Stack, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';

import { PDFViewer } from 'components/PDFViewer/PDFViewer';
import { ImageViewer } from 'components/ImageViewer/ImageViewer';
import { FileListItem } from 'features/frameworkAgreements/components/FileListItem';
import { donwloadFileFromURL } from 'features/frameworkAgreements/api/downloadFile';
import { downloadApplicationFile } from '../../api/downloadApplicationFile';
import { useApplicationFilePreview } from '../../api/previewApplicationFile';

const filesTabName = 'files';

export const ApplicationFilesTab = ({ currentTab, application }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [previewFileID, setPreviewFileID] = useState(null);
  const applicationID = application?.application_id;

  const {
    data: { url, name, mimeType },
  } = useApplicationFilePreview({ applicationID, fileID: previewFileID });

  if (currentTab !== filesTabName || !application) return null;

  const files = application.files ?? [];
  const sections = [
    { title: 'CV', files: files.filter((file) => file.kind === 'cv') },
    { title: 'Additional files', files: files.filter((file) => file.kind === 'additional') },
  ];

  const handleDownload = (fileID) =>
    downloadApplicationFile({ applicationID, fileID }).catch(() =>
      enqueueSnackbar('Failed to download file', { variant: 'error' })
    );

  const closePreview = () => setPreviewFileID(null);
  const handlePreviewDownload = () => donwloadFileFromURL(url, name);

  return (
    <Stack gap={3} py={2}>
      {sections.map((section) => (
        <Stack key={section.title} gap={1}>
          <Typography variant="h6">{section.title}</Typography>
          {section.files.length === 0 && <Typography variant="body2">-</Typography>}
          {section.files.map((file) => (
            <FileListItem
              key={file.file_id}
              handleFilePreview={() => setPreviewFileID(file.file_id)}
              handleDownload={() => handleDownload(file.file_id)}
              dense={false}
              {...file}
            />
          ))}
        </Stack>
      ))}

      <PDFViewer
        url={url}
        open={!!previewFileID && !!url && mimeType.includes('application/pdf')}
        close={closePreview}
        handleDownload={handlePreviewDownload}
        canDownload
      />
      <ImageViewer
        url={url}
        open={!!previewFileID && !!url && mimeType.includes('image/')}
        close={closePreview}
        handleDownload={handlePreviewDownload}
      />
    </Stack>
  );
};
